import { render, staticRenderFns } from "./tradingAnalysis.vue?vue&type=template&id=7ffcad9a&scoped=true"
import script from "./tradingAnalysis.vue?vue&type=script&lang=ts"
export * from "./tradingAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./tradingAnalysis.vue?vue&type=style&index=0&id=7ffcad9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffcad9a",
  null
  
)

export default component.exports